class ToggleSearch extends HTMLElement {
  constructor() {
    super();

    this.wrap = document.querySelector(".petzyo-header-container");
    if (!this.wrap) return;

    this.addEventListener("click", this.open.bind(this));

    this.closeBtn = document.querySelector("close-search");
    if (!this.closeBtn) return;
    this.closeBtn.addEventListener("click", this.close.bind(this));
  }

  open() {
    this.wrap.classList.add("search-opening");
  }

  close() {
    this.wrap.classList.remove("search-opening");
  }
}
customElements.define("open-search", ToggleSearch);

class OpenMenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.open.bind(this));
  }

  open() {
    document.body.classList.add("menu-drawer-opening");
  }
}
customElements.define("open-menu-drawer", OpenMenuDrawer);

class CloseMenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.close.bind(this));
  }

  close() {
    document.body.classList.remove("menu-drawer-opening");
  }
}
customElements.define("close-menu-drawer", CloseMenuDrawer);

class ToggleMenu extends HTMLElement {
  constructor() {
    super();

    this.wrap = this.closest(".toggle-menu-wrap");
    this.addEventListener("click", this.toggle.bind(this));
  }

  toggle() {
    this.wrap.classList.toggle("opening");
  }
}
customElements.define("toggle-menu", ToggleMenu);

class OpenRewards extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.openRewards.bind(this));
  }

  openRewards() {
    document.body.classList.add("rewards-opening");
  }

  // closeRewards() {
  //   document.body.classList.remove("rewards-opening");
  // }
}
customElements.define("open-rewards", OpenRewards);

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelectorAll('close-rewards').length > 0) {
    document.querySelector('close-rewards').addEventListener("click", () => {
      document.body.classList.remove("rewards-opening");
    });
  }
});

class VideoBox extends HTMLElement {
  constructor() {
    super();

    this.box = document.querySelector(".megamenu-video-box-wrap");
    if (!this.box) return;

    this.addEventListener("click", this.toggle.bind(this));
  }

  toggle() {
    document.body.classList.toggle("video-box-opening");
  }
}
customElements.define("video-box", VideoBox);

class MegamenuProducts extends HTMLElement {
  constructor() {
    super();

    var elem = this;
    var flkty = new Flickity(elem, {
      // options
      cellAlign: "left",
      contain: true,
      pageDots: false,
      watchCSS: true,
    });
  }
}
customElements.define("megamenu-products", MegamenuProducts);

document.addEventListener("DOMContentLoaded", function () {
  calHeaderHeight();
  megamenuImage();
});

window.addEventListener("resize", function () {
  calHeaderHeight();
});

function calHeaderHeight() {
  if (document.querySelectorAll(".petzyo-header").length > 0) {
    document.documentElement.style.setProperty("--header-height", document.querySelector(".petzyo-header").offsetHeight + "px");
  }
}

function megamenuImage() {
  if (document.querySelectorAll('.js-petzyo-menu-grandchildlink').length > 0) {
    document.querySelectorAll('.js-petzyo-menu-grandchildlink').forEach((headerLink) => {
      headerLink.addEventListener('mouseover', function (e) {
        let menuParent = e.target.closest(".megamenu-wrap");
        if (!menuParent) return;

        let dataHandle = e.currentTarget.getAttribute('data-handle');

        if (menuParent.querySelectorAll('.megamenu-right-wrap[data-handle="' + dataHandle + '"]').length > 0) {
          if (menuParent.querySelectorAll('.megamenu-right-wrap.active').length > 0) {
            menuParent.querySelector('.megamenu-right-wrap.active').classList.remove('active');
          }
          menuParent.querySelector('.megamenu-right-wrap[data-handle="' + dataHandle + '"]').classList.add('active');
        } else {
          if (menuParent.querySelectorAll('.megamenu-right-wrap.active[data-handle="default"]').length == 0 && menuParent.querySelectorAll('.megamenu-right-wrap[data-handle="default"]').length > 0) {
            if (menuParent.querySelectorAll('.megamenu-right-wrap.active').length > 0) {
              menuParent.querySelector('.megamenu-right-wrap.active').classList.remove('active');
            }
            menuParent.querySelector('.megamenu-right-wrap[data-handle="default"]').classList.add('active');
          }
        }
      });
      headerLink.addEventListener('mouseleave', function (e) {
        let menuParent = e.target.closest(".megamenu-wrap");
        if (!menuParent) return;

        if (menuParent.querySelectorAll('.megamenu-right-wrap.active[data-handle="default"]').length == 0 && menuParent.querySelectorAll('.megamenu-right-wrap[data-handle="default"]').length > 0) {
          if (menuParent.querySelectorAll('.megamenu-right-wrap.active').length > 0) {
            menuParent.querySelector('.megamenu-right-wrap.active').classList.remove('active');
          }
          menuParent.querySelector('.megamenu-right-wrap[data-handle="default"]').classList.add('active');
        }
      });
    });
  }
}

class CartCount extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    if (document.querySelectorAll("mini-cart .js-mini-cart-count").length > 0) {
      let itemCount = parseInt(document.querySelector("mini-cart .js-mini-cart-count").getAttribute("data-count"), 10);
      if (itemCount > 0) {
        document.querySelectorAll(".js-header-cart-count").forEach((el) => {
          el.innerHTML = itemCount;
          el.parentNode.classList.remove("hidden");
        });
      }
    }
  }
}
customElements.define("cart-count", CartCount);